import { useDispatch } from 'react-redux';
import { AppDispatch } from 'reduxStore/store';

const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;

